module.exports = __webpack_public_path__ + "img/vjetrenjaca-2.960b00e9.jpg";